import { GridRowId, useGridApiContext, useGridSelector } from '@mui/x-data-grid-premium';
import { useMemo } from 'react';

export default function useResponsiveCellEditValue({
  fieldToSelect,
  fieldToWatch = fieldToSelect,
  id,
  value,
}: {
  /**
   * Required to be the field we want to get the updated value for
   * If wrong field is provided, then we won't get the updated value.
   */
  fieldToSelect: string;
  /**
   * This field is the one that we want to watch for changes
   * If not provided, it will default to fieldToSelect
   */
  fieldToWatch?: string;
  id: GridRowId;
  value?: any;
}) {
  const apiRef = useGridApiContext();
  // exists to trigger row to rerender when the value we're listening for changes
  const updatedValue = useGridSelector(
    apiRef,
    (gridApiRef) => gridApiRef.current?.state?.editRows?.[id]?.[fieldToWatch]
  );
  const mode = apiRef.current.getRowMode(id);

  // biome-ignore lint/correctness/useExhaustiveDependencies(updatedValue): We depend on this value to trigger rerender
  return useMemo(() => {
    if (mode === 'view') {
      return value;
    }

    return apiRef.current.getRowWithUpdatedValues(id, fieldToWatch)?.[fieldToSelect];
  }, [updatedValue, fieldToWatch, fieldToSelect, id, apiRef, mode, value]);
}
